import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { FluentProvider, webLightTheme } from '@fluentui/react-components'
import { MsalProvider } from '@azure/msal-react'
import { createNestablePublicClientApplication } from '@azure/msal-browser'

import { msalConfig } from '../auth/config'

import App from './App'

async function bootstrap () {
  await window.Office.onReady()

  const pca = await createNestablePublicClientApplication(msalConfig)

  const rootElement = document.getElementById('container')
  const root = rootElement ? createRoot(rootElement) : undefined

  root?.render(
    <MsalProvider instance={pca}>
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </MsalProvider>
  )

  if (module.hot) {
    module.hot.accept('./App', () => {
      const NextApp = require('./App').default
      root?.render(NextApp)
    })
  }
}

bootstrap()
